import { render, staticRenderFns } from "./AddEditComment.vue?vue&type=template&id=7db9bed3&"
import script from "./AddEditComment.vue?vue&type=script&lang=js&"
export * from "./AddEditComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports